document.addEventListener("DOMContentLoaded", () => {
  function formatPriceText(text) {
    if (!text) return "";

    if (text.includes("[") && text.includes("]")) {
      const parts = text.split("[");
      let result = parts[0];

      for (let i = 1; i < parts.length; i++) {
        const inner = parts[i].split("]");
        const boldText = inner[0] || "";
        const remaining = inner[1] || "";

        result += `<strong>${boldText}</strong>${remaining}`;
      }

      return result;
    }

    return text;
  }

  const sections = document.querySelectorAll(".custom-sticky-cta");

  // GET VARIANT FROM URL
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariantId = urlParams.get("variant");

  // GLOBAL LISTENER (SYNC FROM 360 → CTA)
  document.addEventListener("variant:change", (e) => {
    if (e.detail.source === "cta") return;

    const variantId = e.detail.variantId;

    sections.forEach((section) => {
      const variants = section.querySelectorAll(".csc-variant");
      const priceEl = section.querySelector(".csc-price");

      variants.forEach((v) => {
        v.classList.remove("active");

        if (v.dataset.variantId === variantId) {
          v.classList.add("active");
          section.dataset.selectedVariantId = variantId;

          // SHOW LOADING UNTIL 360 RETURNS THE FINAL PRICE
          if (priceEl) {
            priceEl.innerHTML = `
              Starting At
              <strong>Loading...</strong>
              Ex Showroom Price*
            `;
          }
        }
      });
    });
  });

  document.addEventListener("locationPrice:change", (e) => {
    const { variantId, price, location } = e.detail;

    sections.forEach((section) => {
      if (section.dataset.selectedVariantId !== variantId) return;

      const priceEl = section.querySelector(".csc-price");

      if (!priceEl) return;

      priceEl.innerHTML = `
        Starting At
        <strong>${price}</strong>
        Ex Showroom ${location}
      `;
    });
  });

  // PER SECTION LOGIC
  sections.forEach((section) => {
    const variants = section.querySelectorAll(".csc-variant");
    const addToCartBtn = section.querySelector("#csc-add-to-cart");
    const buttonContainer = section.querySelector(".csc-buttons");

    if (!buttonContainer) return;

    // MESSAGE ELEMENT (always last)
    let messageEl = section.querySelector(".csc-message");
    if (!messageEl) {
      messageEl = document.createElement("div");
      messageEl.className = "csc-message";
      buttonContainer.appendChild(messageEl);
    }

    function showMessage(text, type = "error") {
      messageEl.textContent = text;
      messageEl.style.display = "block";
      messageEl.style.color = type === "error" ? "red" : "green";

      setTimeout(() => {
        messageEl.style.display = "none";
      }, 3000);
    }

    // INITIAL STATE (FIXED)
    let initialVariantId = null;

    if (urlVariantId) {
      initialVariantId = urlVariantId;
    } else if (variants.length) {
      initialVariantId = variants[0].dataset.variantId;
    }

    if (initialVariantId) {
      section.dataset.selectedVariantId = initialVariantId;

      variants.forEach((v) => {
        v.classList.remove("active");

        if (v.dataset.variantId === initialVariantId) {
          v.classList.add("active");
        }
      });
    }

    const activeVariant = section.querySelector(
      `.csc-variant[data-variant-id="${initialVariantId}"]`,
    );
    const priceEl = section.querySelector(".csc-price");

    if (activeVariant && priceEl) {
      const priceText = activeVariant.dataset.price || "";

      priceEl.innerHTML = formatPriceText(priceText);
    }

    // VARIANT CLICK
    variants.forEach((btn) => {
      btn.addEventListener("click", () => {
        variants.forEach((v) => v.classList.remove("active"));
        btn.classList.add("active");

        const variantId = btn.dataset.variantId;

        section.dataset.selectedVariantId = variantId;

        // UPDATE URL (important for refresh sync)
        history.replaceState(null, "", `?variant=${variantId}`);

        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: {
              variantId: variantId,
              source: "cta",
            },
          }),
        );
      });
    });

    // OPEN PREBOOK MODAL
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", async () => {
        const variantId = section.dataset.selectedVariantId;
        if (!variantId) return;

        const modal = document.getElementById("prebook-popup-modal");
        const variantInput = modal?.querySelector(".prebook-variant-id");

        try {
          const cartRes = await fetch("/cart.js");
          const cart = await cartRes.json();

          const alreadyExists = cart.items.some(
            (item) => item.variant_id == variantId,
          );

          if (alreadyExists) {
            showMessage("This variant is already added to cart");
            return;
          }

          // OPEN SAME MODAL
          if (modal && variantInput) {
            variantInput.value = variantId;

            // RESET MODAL STATE
            modal.querySelectorAll("select").forEach((select) => {
              select.selectedIndex = 0;
            });

            modal.querySelector('[name="properties[City]"]').disabled = true;
            modal.querySelector('[name="properties[Dealer]"]').disabled = true;
            modal.querySelector(".go-to-checkout").disabled = true;

            if (window.resetPrebookModal) {
              window.resetPrebookModal(); // 🔥 critical fix
            }

            modal.classList.add("open");
            document.body.classList.add("no-scroll");
          }
        } catch (error) {
          console.error("Cart check error:", error);
          showMessage("Something went wrong. Please try again.");
        }
      });
    }
  });

  // PREBOOK MODAL INIT
  function initPrebookModal() {
    const modal = document.getElementById("prebook-popup-modal");
    if (!modal || modal._initialized) return;

    modal._initialized = true;

    if (!window.DealersLoader) {
      console.error("DealersLoader not found");
      return;
    }

    const overlay = modal.querySelector(".popup-overlay");
    const closeBtn = modal.querySelector(".popup-close-icon");

    const stateSelect = modal.querySelector('[name="properties[State]"]');
    const citySelect = modal.querySelector('[name="properties[City]"]');
    const dealerSelect = modal.querySelector('[name="properties[Dealer]"]');
    const submitBtn = modal.querySelector(".go-to-checkout");
    const form = modal.querySelector("form");

    let dealersData = [];
    let isSubmitting = false;

    // RESET FUNCTION
    function resetModalState() {
      // reset selects
      stateSelect.selectedIndex = 0;
      citySelect.innerHTML = '<option value="">Select City</option>';
      dealerSelect.innerHTML = '<option value="">Select Dealer</option>';

      citySelect.disabled = true;
      dealerSelect.disabled = true;

      // reset button
      submitBtn.classList.remove("loading");
      submitBtn.disabled = true;
      submitBtn.style.pointerEvents = "auto";

      // reset text (optional safety)
      const text = submitBtn.querySelector(".btn-text");
      if (text) text.textContent = "Submit";

      // reset internal state
      isSubmitting = false;
    }

    function closeModal() {
      modal.classList.remove("open");
      document.body.classList.remove("no-scroll");

      resetModalState();
    }

    overlay.addEventListener("click", closeModal);
    closeBtn.addEventListener("click", closeModal);

    // ESC support (bonus)
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });

    // LOAD DEALERS
    (async () => {
      try {
        dealersData = await window.DealersLoader.load();

        if (!Array.isArray(dealersData)) {
          dealersData = dealersData.data || [];
        }

        const states = [...new Set(dealersData.map((d) => d.state))];

        // clear before append
        stateSelect.innerHTML = '<option value="">Select State</option>';

        states.forEach((state) => {
          const opt = document.createElement("option");
          opt.value = state;
          opt.textContent = state;
          stateSelect.appendChild(opt);
        });
      } catch (err) {
        console.error("Dealer load failed", err);
      }
    })();

    // STATE → CITY
    stateSelect.addEventListener("change", () => {
      citySelect.innerHTML = '<option value="">Select City</option>';
      dealerSelect.innerHTML = '<option value="">Select Dealer</option>';

      citySelect.disabled = true;
      dealerSelect.disabled = true;

      if (!stateSelect.value) return;

      const cities = [
        ...new Set(
          dealersData
            .filter((d) => d.state === stateSelect.value)
            .map((d) => d.city),
        ),
      ];

      cities.forEach((city) => {
        const opt = document.createElement("option");
        opt.value = city;
        opt.textContent = city;
        citySelect.appendChild(opt);
      });

      citySelect.disabled = false;
    });

    // CITY → DEALER
    citySelect.addEventListener("change", () => {
      dealerSelect.innerHTML = '<option value="">Select Dealer</option>';
      dealerSelect.disabled = true;

      if (!citySelect.value) return;

      const dealers = dealersData.filter(
        (d) => d.state === stateSelect.value && d.city === citySelect.value,
      );

      dealers.forEach((d) => {
        const opt = document.createElement("option");
        opt.value = d.dealer;
        opt.textContent = d.dealer;
        dealerSelect.appendChild(opt);
      });

      dealerSelect.disabled = false;
    });

    // VALIDATION
    function validate() {
      submitBtn.disabled = !(
        stateSelect.value &&
        citySelect.value &&
        dealerSelect.value
      );
    }

    stateSelect.addEventListener("change", validate);
    citySelect.addEventListener("change", validate);
    dealerSelect.addEventListener("change", validate);

    // SUBMIT (ANTI DOUBLE CLICK)
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      if (submitBtn.disabled || isSubmitting) return;

      isSubmitting = true;

      submitBtn.classList.add("loading");
      submitBtn.disabled = true;
      submitBtn.style.pointerEvents = "none";

      const variantId = modal.querySelector(".prebook-variant-id").value;

      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              State: stateSelect.value,
              City: citySelect.value,
              Dealer: dealerSelect.value,
            },
          }),
        });

        window.location.href = "/cart";
      } catch (err) {
        console.error(err);

        isSubmitting = false;
        submitBtn.classList.remove("loading");
        submitBtn.disabled = false;
        submitBtn.style.pointerEvents = "auto";
      }
    });

    // EXPOSE RESET GLOBALLY
    window.resetPrebookModal = resetModalState;
  }

  // INIT
  initPrebookModal();

  // FORCE SYNC ON PAGE LOAD (VERY IMPORTANT)
  if (urlVariantId) {
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: {
          variantId: urlVariantId,
          source: "init",
        },
      }),
    );
  }

  // Handle button wrapping on mobile
  function handleButtonWrap() {
    const isMobile = window.innerWidth <= 767;

    document.querySelectorAll(".custom-sticky-cta").forEach((section) => {
      const buttonsContainer = section.querySelector(".csc-buttons");
      const primaryBtn = section.querySelector(".csc-btn-primary");
      const outlineBtn = section.querySelector(".csc-btn-outline");
      const messageEl = section.querySelector(".csc-message");

      if (!buttonsContainer || !primaryBtn || !outlineBtn) return;

      let wrapper = section.querySelector(".csc-mobile-btn-wrapper");

      // MOBILE → WRAP
      if (isMobile) {
        if (!wrapper) {
          wrapper = document.createElement("div");
          wrapper.className = "csc-mobile-btn-wrapper";

          // Move buttons into wrapper
          wrapper.appendChild(primaryBtn);
          wrapper.appendChild(outlineBtn);

          // Append wrapper first
          buttonsContainer.appendChild(wrapper);

          // Always keep message LAST
          if (messageEl) {
            buttonsContainer.appendChild(messageEl);
          }
        }
      }

      // DESKTOP → UNWRAP
      else {
        if (wrapper) {
          buttonsContainer.appendChild(primaryBtn);
          buttonsContainer.appendChild(outlineBtn);

          wrapper.remove();

          // Keep message LAST
          if (messageEl) {
            buttonsContainer.appendChild(messageEl);
          }
        }
      }
    });
  }

  handleButtonWrap();
  window.addEventListener("resize", handleButtonWrap);

  // Trigger sticky CTA visibility based on scroll position
  const sticky = document.querySelector(".custom-sticky-cta");
  const triggerSection = document.querySelector(".custom-feature-text");
  const footer = document.querySelector(".social-footer-container");

  if (!sticky || !triggerSection) return;

  function handleScroll() {
    const triggerTop = triggerSection.getBoundingClientRect().top;
    const footerRect = footer ? footer.getBoundingClientRect() : null;
    const windowHeight = window.innerHeight;

    const reachedTrigger = triggerTop <= windowHeight * 0.8;
    const reachedFooter = footerRect && footerRect.top <= windowHeight;

    if (reachedTrigger && !reachedFooter) {
      sticky.style.transform = "translateY(0)";
    } else {
      sticky.style.transform = "translateY(100%)";
    }
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll();
});

// FIX BACK BUTTON CACHE ISSUE
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    const modal = document.getElementById("prebook-popup-modal");

    if (modal) {
      // close modal
      modal.classList.remove("open");
      document.body.classList.remove("no-scroll");

      // reset state
      if (window.resetPrebookModal) {
        window.resetPrebookModal();
      }
    }
  }
});
